import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Chart } from 'primereact/chart';
import { Api } from "../../../services/api";
import axios from "axios";
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';
import './TeamScore.css';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Dropdown } from "primereact/dropdown";

const HuddlesConversationReports = () => {
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [overallAverage, setOverallAverage] = useState({ cultural: 0, jobSatisfaction: 0 });

    const [groupedData, setGroupedData] = useState({
        Q1: [], Q2: [], Q3: [], Q4: []
    });
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
    const cities = [
        { name: '2021', value: '2021' },
        { name: '2022', value: '2022' },
        { name: '2023', value: '2023' },
        { name: '2024', value: '2024' },
        { name: '2025', value: '2025' },
        { name: '2026', value: '2026' },
        { name: '2027', value: '2027' },
        { name: '2028', value: '2028' },
    
        // Add more cities as needed
      ];
    const [quarterAverages, setQuarterAverages] = useState({
        Q1: { cultural: 0, jobSatisfaction: 0 },
        Q2: { cultural: 0, jobSatisfaction: 0 },
        Q3: { cultural: 0, jobSatisfaction: 0 },
        Q4: { cultural: 0, jobSatisfaction: 0 }
    });

    const [activeQuarter, setActiveQuarter] = useState([0, 1, 2, 3]); // Set all quarters to be open by default

    const getProject = async (year) => {
        try {
            const token = localStorage.getItem('authToken');
            const headers = {
                'Authorization': token ? `Bearer ${token}` : '',
                "Content-Type": "application/json",
            };
            const response = await axios.get(Api.API_BASE_URL + '555/history/'+year, { headers: headers });
            const result = response.data.history;
            setProjects(result);
            setIsLoading(false);
            processAndGroupData(result);
        } catch (error) {
            setIsLoading(false);
            console.error('Error:', error);
        }
    };

    const processAndGroupData = (data) => {
        const grouped = { Q1: [], Q2: [], Q3: [], Q4: [] };
        const averages = {
            Q1: { cultural: 0, jobSatisfaction: 0, count: 0 },
            Q2: { cultural: 0, jobSatisfaction: 0, count: 0 },
            Q3: { cultural: 0, jobSatisfaction: 0, count: 0 },
            Q4: { cultural: 0, jobSatisfaction: 0, count: 0 }
        };
        let totalCultural = 0, totalJobSatisfaction = 0, totalCount = 0, totaljobCount = 0;

        data.forEach(item => {
            if (item != null && item != undefined) {
                const { quarter, cultutalPoint, jobSatisfactionPoint } = item;
                const quarterKey = quarter;

                // Check if the quarterKey is valid (Q1, Q2, Q3, Q4)
                if (grouped[quarterKey]) {
                    const cultural = Number(cultutalPoint) || 0;
                    const jobSatisfaction = Number(jobSatisfactionPoint) || 0;
                    grouped[quarterKey].push(item);

                    // Accumulate points for averages
                    averages[quarterKey].cultural += cultural;
                    averages[quarterKey].jobSatisfaction += jobSatisfaction;
                    if (cultural != 0) {
                        averages[quarterKey].count += 1;
                    }

                    // Overall averages
                    if (cultural != 0) {
                        totalCultural += cultural;
                        totalJobSatisfaction += jobSatisfaction;
                        totalCount += 1;
                    }
                } else {
                    console.warn(`Invalid quarter: ${quarterKey}`); // Debugging line
                }
            }
        });

        // Calculate averages for each quarter
        Object.keys(averages).forEach(quarterKey => {
            if (averages[quarterKey].count > 0) {
                averages[quarterKey].cultural /= averages[quarterKey].count;
                averages[quarterKey].jobSatisfaction /= averages[quarterKey].count;
            }
        });

        setGroupedData(grouped);
        setQuarterAverages({
            Q1: { cultural: averages.Q1.cultural, jobSatisfaction: averages.Q1.jobSatisfaction },
            Q2: { cultural: averages.Q2.cultural, jobSatisfaction: averages.Q2.jobSatisfaction },
            Q3: { cultural: averages.Q3.cultural, jobSatisfaction: averages.Q3.jobSatisfaction },
            Q4: { cultural: averages.Q4.cultural, jobSatisfaction: averages.Q4.jobSatisfaction }
        });

        // Set overall average
        setOverallAverage({
            cultural: totalCount > 0 ? totalCultural / totalCount : 0,
            jobSatisfaction: totalCount > 0 ? totalJobSatisfaction / totalCount : 0
        });
    };


    // Highlight cells based on value
    const highlightCell = (value) => {
        return (
            <div className={value >= 8 ? "green-cell" : "red-cell"}>
                {value}
            </div>
        );
    };

    // Check current quarter
    useEffect(() => {
        const currentMonth = new Date().getMonth() + 1;
        let currentQuarterIndex = 1; // Default to Q4 (index 3 for 0-based array)

        if (currentMonth >= 1 && currentMonth <= 3) currentQuarterIndex = 0;
        else if (currentMonth >= 4 && currentMonth <= 6) currentQuarterIndex = 1;
        else if (currentMonth >= 7 && currentMonth <= 9) currentQuarterIndex = 2;

        // Keep all quarters expanded by default
        setActiveQuarter([0, 1, 2, 3]);
        getProject(selectedYear);
    }, []);

    const chartOptions = {
        plugins: {
            legend: {
                position: 'right', // Position of the legend
            },
            datalabels: {
                formatter: (value, context) => {
                    const total = context.chart.data.datasets[0].data.reduce((acc, val) => acc + val, 0);
                    if (total > 0) {
                        const percentage = ((value / total) * 100).toFixed(2) + '%';
                        return percentage; // Display percentage
                    } else {
                        return ''; // Avoid NaN display
                    }
                },
                color: '#fff', // Color of the labels
            },
        },
        responsive: true,
        maintainAspectRatio: false,
    };

    // Pie chart data for cultural and job satisfaction points
    const culturalData = {
        labels: ['Q1', 'Q2', 'Q3', 'Q4'],
        datasets: [{
            data: [
                quarterAverages.Q1.cultural.toFixed(2),
                quarterAverages.Q2.cultural.toFixed(2),
                quarterAverages.Q3.cultural.toFixed(2),
                quarterAverages.Q4.cultural.toFixed(2)
            ],
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
            hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0']
        }]
    };

    const jobSatisfactionData = {
        labels: ['Q1', 'Q2', 'Q3', 'Q4'],
        datasets: [{
            data: [
                quarterAverages.Q1.jobSatisfaction.toFixed(2),
                quarterAverages.Q2.jobSatisfaction.toFixed(2),
                quarterAverages.Q3.jobSatisfaction.toFixed(2),
                quarterAverages.Q4.jobSatisfaction.toFixed(2)
            ],
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
            hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0']
        }]
    };
    const customItemTemplate = (option) => (
        <div style={{ padding: '8px' }}>
          {option.name}
        </div>
      );
      const onYearChange = (e) => {
        setSelectedYear(e.value);// Update selected year state when a year is chosen
        getProject(e.value);
      };
    return (
        <>
            {isLoading ? (
                <div>Loading...</div>
            ) : (
                <>
                    <div className="team-score-subtitle">
                        <div className="average-item">Overall Average for Year: <Dropdown inputId="year" options={cities} optionLabel="name" className="w-full md:w-6rem  " style={{ height: '40px', padding: '8px', }} itemTemplate={customItemTemplate} value={selectedYear} onChange={onYearChange} /></div>
                    </div>
                    <div className="average-display">
                        <div className="average-item">Overall Average Cultural Points: {overallAverage.cultural.toFixed(2)}</div>
                        <div className="average-item">Overall Average Job Satisfaction Points: {overallAverage.jobSatisfaction.toFixed(2)}</div>
                    </div>

                    <div className="reports-container">
                        <div className="charts-container">
                            <div className="chart-item">
                                <Chart type="pie" data={culturalData} options={chartOptions} plugins={[ChartDataLabels]} />
                                <h4 className="title-font">Cultural Points Average per Quarter</h4>
                            </div>
                            <div className="chart-item">
                                <Chart type="pie" data={jobSatisfactionData} options={chartOptions} plugins={[ChartDataLabels]} />
                                <h4 className="title-font">Job Satisfaction Points Average per Quarter</h4>
                            </div>
                        </div>

                        <Accordion multiple activeIndex={activeQuarter} onTabChange={(e) => setActiveQuarter(e.index)}>
                            {['Q4', 'Q3', 'Q2', 'Q1'].map((quarter, index) => (
                                <AccordionTab
                                    key={quarter}
                                    header={`Quarter ${quarter.replace('Q', '')}`}
                                    headerClassName={`accordion-header-${quarter.toLowerCase()}`}
                                    expanded={true}
                                >
                                    <div className="team-score-subtitle">
                                        <div className="average-item">Year: {selectedYear} </div>
                                        <div className="average-item">Quarter: {quarter.replace('Q', '')} </div>
                                    </div>
                                    <div className="average-display">
                                        <div className="average-item">Average Cultural Points: {quarterAverages[quarter].cultural.toFixed(2)}</div>
                                        <div className="average-item">Average Job Satisfaction Points: {quarterAverages[quarter].jobSatisfaction.toFixed(2)}</div>
                                    </div>
                                    <DataTable value={groupedData[quarter]} paginator rows={20} scrollable scrollHeight="800px" className="p-datatable">
                                        <Column field="office" header="OFFICE" style={{ width: '200px' }}></Column>
                                        <Column field="supervisor" header="SUPERVISOR" style={{ width: '200px' }}></Column>
                                        <Column field="name" header="NAME" style={{ width: '200px' }}></Column>
                                        <Column field="title" header="TITLE" style={{ width: '200px' }}></Column>
                                        <Column field="cultutalPoint" header="CULTURAL POINTS" style={{ width: '150px' }} body={(rowData) => highlightCell(rowData.cultutalPoint)}></Column>
                                        <Column field="jobSatisfactionPoint" header="JOB SATISFACTION POINTS" style={{ width: '200px' }} body={(rowData) => highlightCell(rowData.jobSatisfactionPoint)}></Column>
                                    </DataTable>
                                </AccordionTab>
                            ))}
                        </Accordion>
                    </div>
                </>
            )}
        </>
    );

};

export default HuddlesConversationReports;
